import { Flex } from 'antd';
import { WeekdayNumbers } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';

import { getItemsDataForWeek, getSetOfWeekDateByDate } from '../functions';
import { RootState } from '../store';
import { ItemType } from '../types';
import CalendarItemMonth from './calendarItemMonth';

const CalendarHeaderItems: React.FC = () => {
    const filteredItems = useSelector<RootState, ItemType[]>((state) => state.calendar.filteredItems);

    const currentDate = useSelector<RootState, string>((state) => state.calendar.currentDate);

    const setOfDaysWeek = getSetOfWeekDateByDate(currentDate);

    const newItemsDataByWeekDay = getItemsDataForWeek(setOfDaysWeek, filteredItems);

    const processedItemsDataByWeekDay = newItemsDataByWeekDay.map((lineOfItems) => {
        const newLineOfItems: (ItemType | null)[] = [];
        const counter: { [id: string]: number } = {};
        const newArrayId = new Set();
        lineOfItems.forEach((item) => {
            if (item) {
                if (!newArrayId.has(item.id)) {
                    newArrayId.add(item.id);
                    newLineOfItems.push(item);
                    counter[item.id] = 0;
                }
                counter[item.id] += 1;
            } else {
                newLineOfItems.push(null);
            }
        });
        return { counter, lineOfItems: newLineOfItems };
    });

    return (
        <>
            {processedItemsDataByWeekDay.map((dataLineOfItems, index) => {
                return (
                    <Flex key={index} justify={'space-around'}>
                        {dataLineOfItems.lineOfItems.map((item, subIndex) => {
                            const day = subIndex + 1;
                            const keyValue = item ? `${day}-${item.id}` : `${day}-null`;
                            return (
                                <CalendarItemMonth
                                    length={item ? dataLineOfItems.counter[item.id] : 1}
                                    key={keyValue}
                                    day={day as WeekdayNumbers}
                                    item={item}
                                    currentDate={currentDate}
                                    forceCaption
                                />
                            );
                        })}
                    </Flex>
                );
            })}
        </>
    );
};

export default CalendarHeaderItems;
